import { useEffect, useState } from 'react';

interface ApiConfig {
  API_URL: string;
}

export const useApiConfig = () => {
  const [apiUrl, setApiUrl] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        // Try to fetch config.json from the same origin (served by CloudFront)
        const response = await fetch('/config.json');
        
        if (!response.ok) {
          throw new Error(`Failed to fetch config: ${response.status}`);
        }
        
        const config: ApiConfig = await response.json();
        if (config.API_URL) {
          setApiUrl(config.API_URL);
        } else {
          throw new Error('API_URL not found in config');
        }
      } catch (err) {
        // Fallback to environment variable if config.json not found
        const fallbackUrl = process.env.REACT_APP_API_URL || '';
        if (fallbackUrl) {
          setApiUrl(fallbackUrl);
          console.warn('Using fallback API URL from environment:', fallbackUrl);
        } else {
          setError('Failed to load API configuration');
          console.error('Error loading config:', err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return { apiUrl, loading, error };
};
